import { render, staticRenderFns } from "./WaardenGame.vue?vue&type=template&id=e8d96a3c&scoped=true&"
import script from "./WaardenGame.vue?vue&type=script&lang=js&"
export * from "./WaardenGame.vue?vue&type=script&lang=js&"
import style0 from "./WaardenGame.vue?vue&type=style&index=0&id=e8d96a3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d96a3c",
  null
  
)

export default component.exports